import React from 'react'
import styled from 'styled-components'

import LatinoTemplateDefault from 'src/components/template/la/'
import { videos } from 'src/constants/videos'
import { laChannelCount } from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'
import { leagueIds, sportIds } from 'src/constants'

export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'es' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null

  let title = (
    <>
      Mira la MLB en vivo <span className="no-wrap">en español</span>
    </>
  )
  let subtitle = `Disfruta del béisbol toda la temporada y accede a más de 50 canales de TV en vivo en español`
  if (latinoBundlePlan?.rsnName) {
    title = (
      <>
        Mira la MLB <span className="no-wrap">en vivo</span>
      </>
    )
    subtitle = `Sigue a tu equipo local con ${
      latinoBundlePlan?.rsnName ?? 'FanDuel Sports Network'
    } y más de ${laChannelCount} canales de TV en vivo`
  }

  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="es"
        market="latino"
        video={videos.mlbtv.videoUrl}
        title={title}
        subtitle={subtitle}
        networkSet={'entertainmentLatino'}
        customNetworks={['espndeportes']}
        noteLink="/la/mlb/"
        pageDescription={
          'Transmite canales de FanDuel Sports Network, FOX Deportes, ESPN Deportes, beIN SPORTS y más con Fubo.'
        }
        disableLAPlanCards={isLatinoBundleAvailable}
        forceAnchorLink={isLatinoBundleAvailable}
        hasPlanCards={isLatinoBundleAvailable}
        plans={[latinoBundlePlan]}
        sportId={sportIds.Baseball}
        leagueId={leagueIds.MLB}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
